import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, addActionNameToMutationResult, useAxiosInstance } from 'shared/hooks/utils';
import {
  EMAIL_DOMAIN_QUERY_KEY,
  EMAIL_DOMAIN_URL,
  type EmailDomain,
  parseEmailDomain,
} from './use-load-email-domain';

export async function verifyEmailDomainFn(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;
  const { data } = await instance.post(`${EMAIL_DOMAIN_URL}/verify`);

  return parseEmailDomain(data);
}

export function useVerifyEmailDomain() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<EmailDomain, ApiError, void>({
    mutationFn: () => verifyEmailDomainFn(axiosInstance),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: EMAIL_DOMAIN_QUERY_KEY });
      client.invalidateQueries({ queryKey: ['companyConfigurationV2'] });
    },
  });

  return addActionNameToMutationResult<EmailDomain, ApiError, void, 'verifyEmailDomain'>(
    'verifyEmailDomain',
    mutation,
  );
}
